import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { MarkOutsideProcessContractMovementAsReceivedDto } from "@interfaces/dto/markOutsideProcessContractMovementAsReceivedDto.interface";
import { MarkOutsideProcessContractMovementsAsSentDto } from "@interfaces/dto/markOutsideProcessContractMovementsAsSentDto.interface";
import { Service } from "@services/service";

@Injectable()
export class OutsideProcessContractMovementService extends Service {
	constructor(injector: Injector) {
		super("OutsideProcessContractMovement", injector);
	}

	// API
	app_GetReceivable() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_GetReceivable`);
	}
	
	app_GetSendable() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_GetSendable`);
	}
	
	app_MarkOutsideProcessContractMovementAsReceived(data: MarkOutsideProcessContractMovementAsReceivedDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_MarkOutsideProcessContractMovementAsReceived`, data);
	}
	
	app_markOutsideProcessContractMovementsAsSent(data: MarkOutsideProcessContractMovementsAsSentDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkOutsideProcessContractMovementsAsSent`, data);
	}

	creationDetailsForStage(workOrderStageId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/CreationDetailsForStage/${workOrderStageId}`);
	}
	
	getByOutsideProcessContractId(outsideProcessContactId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByOutsideProcessContractId/${outsideProcessContactId}`);
	}
	
	getReceivable() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetReceivable`);
	}
	
	getSendable() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetSendable`);
	}
	
	markOutsideProcessContractMovementAsReceived(data: MarkOutsideProcessContractMovementAsReceivedDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkOutsideProcessContractMovementAsReceived`, data);
	}
	
	markOutsideProcessContractMovementsAsSent(data: MarkOutsideProcessContractMovementsAsSentDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkOutsideProcessContractMovementsAsSent`, data);
	}
}